import QueryString from 'query-string'

import { Client } from '@termly-web/common'


export default function makeGetFile({ urlTemplate }) {
  return (locale) => {
    // biome-ignore lint/correctness/noUndeclaredVariables: injected at build time by webpack DefinePlugin
    const i18nHash = __I18N_HASH__
    const url = QueryString.stringifyUrl({
      url: urlTemplate.replace(':locale', locale),
      query: { v: i18nHash },
    })

    return Client.get(url, {
      baseURL: '/',
      withCredentials: false,
    })
  }
}
